import {AbstractModel} from '../abstract-model';
import {Partner} from '../partner/partner';
import {Currency} from '../currency';
import {BillingLine} from './billing-line';
import {PartnerDetails} from './partner-details';

export abstract class AbstractBilling extends AbstractModel {
  id: number | null = null;
  partner: Partner | null = null;
  partnerId: number | null = null;
  startingAt: Date | null = null;
  endingAt: Date | null = null;
  totalAmountTaxExcl: number = 0;
  totalVatAmount: number = 0;
  totalAmountTaxIncl: number = 0;
  currencyTotalAmountTaxExcl: number = 0;
  currencyTotalVatAmount: number = 0;
  currencyTotalAmountTaxIncl: number = 0;
  partnerAccountType: string | null = null;
  paymentThreshold: number | null = null;
  paymentTerms: string | null = null;
  paymentCurrency: Currency | null = null;
  updatedAt: Date | null = null;
  createdAt: Date | null = null;
  lines: BillingLine[] = [];
  partnerDetails: PartnerDetails | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.partner) {
      this.partner = new Partner().deserialize(input.partner);
    }

    if (input.lines) {
      this.lines = input.lines.map((line: any) => new BillingLine().deserialize(line));
    }

    if (input.partnerDetails) {
      this.partnerDetails = new PartnerDetails().deserialize(input.partnerDetails);
    }

    return this;
  }

  getVatPercent(): number {
    if (this.totalAmountTaxExcl === 0) {
      return 0;
    }

    return Math.round(this.totalVatAmount / this.totalAmountTaxExcl * 10000) / 100;
  }
}
